import React from "react";
import { ModalFooter, Button } from "react-bootstrap";
import { _t } from "app/i18n/i18n";
import { history } from "redux/configureStore";

export const DisclaimerButtons = () => {
  return (
    <ModalFooter>
      <Button variant="secondary" onClick={history.goBack}>
        {_t("Back")}
      </Button>
      <Button variant="primary" onClick={() => history.push("/")}>
        {_t("Home")}
      </Button>
    </ModalFooter>
  );
};
